import { render, staticRenderFns } from "./AbkOpenIdFrontChannelLogout.vue?vue&type=template&id=41b1d2e6&scoped=true&"
import script from "./AbkOpenIdFrontChannelLogout.vue?vue&type=script&lang=js&"
export * from "./AbkOpenIdFrontChannelLogout.vue?vue&type=script&lang=js&"
import style0 from "./AbkOpenIdFrontChannelLogout.vue?vue&type=style&index=0&id=41b1d2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b1d2e6",
  null
  
)

export default component.exports